import { TemplateElement, html, defineElement, unsafeHTML, when } from '@webtides/element-js';
import style from './content-card.css';
import '../icon/icon.js';

/**
 * @property {string} icon
 * @property {string} headline
 * @property {string} text
 */
export default class ContentCard extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            icon: '',
            headline: '',
            text: '',
        };
    }

    template() {
        return html`
            <div class="bg-green-light25 h-full rounded-2xl p-24 pt-40 flex flex-col gap-16">
                ${when(this.icon, html` <mb-icon name="${this.icon}" size="48"></mb-icon> `)}
                ${when(this.headline, html` <h3 class="text-xl mb-0">${this.headline}</h3> `)}
                ${when(this.text, html` <div class="text-base text-green-light mb-0">${unsafeHTML(this.text)}</div> `)}
            </div>
        `;
    }
}

defineElement('mb-content-card', ContentCard);
